import axios from 'axios';
import { APIURL }  from './index';
import { encodeUrl, checkSexOption } from '../utility/tool';

export const KOLRANKING = 'KOLRANKING';
export const KOLRANKING_ERROR = 'KOLRANKING_ERROR';
export const KOLRANKING_ISLOADING = 'KOLRANKING_ISLOADING';

export function fetch_kolranking(tagarr,catearr,skillarr,jobarr,fansmin,fansmax,period,sex,source,kol_name,cat_op,token,dispatch) {
  const tags = tagarr.join()
  const skills = skillarr === undefined ? []: skillarr.join()
  const jobs = jobarr === undefined ? [] : jobarr.join()
  const covertNumber = 10000
  const fansminCustom = fansmin * covertNumber
  const fansmaxCustom = fansmax * covertNumber
  const sexValue = checkSexOption(sex)
  let url = `${APIURL}/KOLRanking?tags=${tags}&skills=${skills}&jobs=${jobs}&fans_min=${fansminCustom}&fans_max=${fansmaxCustom}&period=${period}&sex=${sexValue}&source=${source}&kol_name=${kol_name}&cat_op=${cat_op}&token=${token}`
  let newEncodeUrl = encodeUrl(url)

  return (dispatch) => {
   const request = axios.get(newEncodeUrl)
   dispatch(kolranking_isloading(true))
   request.then((response) =>{
    dispatch(kolranking_error(false))
    return response; 
   })
  .then((response)=>{
    dispatch(kolranking_success(response))
    dispatch(kolranking_isloading(false))
  })
  .catch((err) => {
    dispatch(kolranking_isloading(false)); 
    return dispatch(kolranking_error(err.response))});
  }
}

export function fetch_kolrankingPost(formdata, token) {
  const url = `${APIURL}/KOLRanking?token=${token}`

  return (dispatch) => {
    dispatch(kolranking_isloading(true))
    const request = axios.post(encodeUrl(url), formdata, {
      headers: {
      'Content-Type': 'application/json'
      }
    })

    request.then((response) =>{
      dispatch(kolranking_error(false))
      return response;
    })
    .then((response)=>{
      dispatch(kolranking_success(response))
      dispatch(kolranking_isloading(false))
    })
    .catch((err) => {
      dispatch(kolranking_isloading(false));
      return dispatch(kolranking_error(err.response))});
    }
}

export function kolranking_isloading(bool){
  return {
    type: KOLRANKING_ISLOADING,
    isLoading: bool
  }
}

export function kolranking_success(response){
  return {
      type:KOLRANKING,
      payload: response
    }
}

export function kolranking_error(bool){
  return {
    type:KOLRANKING_ERROR,
    hasErrored: bool
  }
}


// WEBPACK FOOTER //
// ./src/actions/fetch_kolranking.js